/**
 * Language primitives, kept in their own module so the zustand store and the
 * persistence schema can import them without pulling in the dictionaries —
 * and without a cycle, since ./index.ts imports the store.
 */
export type Language = "en" | "he";

export const LANGUAGES: readonly Language[] = ["en", "he"];
export const DEFAULT_LANGUAGE: Language = "en";

const RTL_LANGUAGES = new Set<Language>(["he"]);

export const isRtl = (language: Language): boolean => RTL_LANGUAGES.has(language);

export const directionFor = (language: Language): "ltr" | "rtl" =>
  isRtl(language) ? "rtl" : "ltr";

export const isLanguage = (value: unknown): value is Language =>
  typeof value === "string" && (LANGUAGES as readonly string[]).includes(value);
